import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Glados = (dbDef) => {
    return {
        glados: {
            query: { method: HttpMethod.GET, path: `v1/${dbDef.dbKey}/query/glados` }
        }
    };
};
//# sourceMappingURL=api-def.js.map